import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

/** Texto vigente de la declaración (cláusula 4.1 de los Términos) y su versión. */
export interface DeclarationText
{
  version: string;
  text: string;
}

/** Lo que se manda al servidor al enviar: si marcó la casilla y qué versión vio. */
export interface DeclarationAcceptance
{
  accepted: boolean;
  version: string;
}

/**
 * Pide al servidor el texto de la declaración. El servidor es la única fuente: aquí no se
 * guarda ninguna copia del texto. Se pide una vez y se reutiliza en todas las pantallas.
 */
@Injectable({ providedIn: 'root' })
export class DeclarationService
{
  private current$: Observable<DeclarationText> = null;

  constructor(private http: HttpClient) { }

  public getCurrent(): Observable<DeclarationText>
  {
    if (!this.current$)
    {
      this.current$ = this.http.get<DeclarationText>('api/Declaration/current').pipe(
        // Si falla, no se queda guardado el error: el siguiente intento vuelve a pedirlo
        catchError(error =>
        {
          this.current$ = null;
          return throwError(error);
        }),
        shareReplay(1));
    }

    return this.current$;
  }
}
